"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListeners = exports.removeListener = exports.addListener = void 0;
const listeners = {};
const addListener = (eventName, func) => {
    listeners[eventName] = listeners[eventName] || [];
    listeners[eventName].push(func);
};
exports.addListener = addListener;
const removeListener = (eventName, func) => {
    listeners[eventName] = listeners[eventName] || [];
    const index = listeners[eventName].indexOf(func);
    if (index > -1) {
        listeners[eventName].splice(index, 1);
    }
};
exports.removeListener = removeListener;
const getListeners = eventName => {
    return listeners[eventName] || [];
};
exports.getListeners = getListeners;
//# sourceMappingURL=store.js.map